<script>
import Layout from "@/layouts/PublicLayout.vue";

export default {
  created() {
    this.$emit("update:layout", Layout);
  }
};
</script>
